var lists_default = {
  "fontElementMap": "RiQBv",
  "orderedlist": "_8XTjB",
  "bulletedlist": "vJVY0",
  "listItem": "Je7QR"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
